import { BlockType } from '../../../types/api/ElementType';
import IForm from '../../../types/IForm';
import { DefaultView, InstantView, Views } from '../../../types/BlockWithViews';

import type { VideoBlock } from '../../../_blocks/VideoBlock';
import type { ContentImageBlock } from '../../../_blocks/ContentImage/ContentImageBlock';
import type { RichTextBlock } from '../../../_blocks/RichText';
import type { GenericSearchListBlock } from '../../../_blocks/GenericSearchList';
import type { ChildPagesBlock } from '../../../_blocks/ChildPages/ChildPagesBlock';
import type { PersonCollectionBlock } from '../../../_blocks/PersonCollection/PersonCollectionBlock';
import type { ImageGalleryBlock } from '../../../_blocks/ImageGallery/ImageGallery';
import type { TableOfContentsBlock } from '../../../_blocks/TableOfContents/TableOfContentsBlock';
import { LayoutGroup } from '../LayoutGroup/LayoutGroup';
import { TicketBookingBlock } from '../../../_blocks/TicketBooking/TicketBookingBlock';
import { ExternalContentBlock } from '../../../_lib/components/ExternalContent';
import { PdfFileDetailsBlock } from '../../../_blocks/PdfFileDetails';
import { CollapsibleContainerBlock } from '../../../_blocks/CollapsibleContainerBlock/CollapsibleContainerBlock';

export type ContentWrapperBlockTypes =
  | BlockType.layoutgroup
  | BlockType.video
  | BlockType.contentimage
  | BlockType.richtext
  | BlockType.genericsearchlist
  | BlockType.childpages
  | BlockType.personcollection
  | BlockType.imagegallery
  | BlockType.ticketbooking
  | BlockType.pdffiledetails
  | BlockType.externalcontent
  | BlockType.collapsiblecontainer;

export type BlockWithAction<T> = T & { actions: Record<string, IForm> };
export type ContentWrapperBlocks =
  | BlockWithAction<VideoBlock>
  | BlockWithAction<ContentImageBlock>
  | BlockWithAction<RichTextBlock>
  | BlockWithAction<GenericSearchListBlock>
  | BlockWithAction<ChildPagesBlock>
  | BlockWithAction<PersonCollectionBlock>
  | BlockWithAction<ImageGalleryBlock>
  | BlockWithAction<LayoutGroup>
  | BlockWithAction<TicketBookingBlock>
  | BlockWithAction<PdfFileDetailsBlock>
  | BlockWithAction<ExternalContentBlock>
  | BlockWithAction<CollapsibleContainerBlock>;

export type AddBlockView = {
  addBlock?: InstantView<{ form: IForm }>;
};

export type ContentWrapperBlockProps = Views<
  AddBlockView & DefaultView<{ tableOfContents?: TableOfContentsBlock; content: ContentWrapperBlocks[] }>
>;

/** Actions defined by the ContentWrapper */
export enum ContentWrapperAction {
  addBlock = 'addBlock',
  moveBlockUp = 'moveBlockUp',
  moveBlockDown = 'moveBlockDown',
  deleteBlock = 'deleteBlock',
  connectBlocks = 'connectBlocks',
}

export type ContentWrapperActionType = (typeof ContentWrapperAction)[keyof typeof ContentWrapperAction];

export enum ContentWrapperError {
  addBlock = 'addBlock',
  fetchError = 'fetchError',
  moveFail = 'moveFail',
}
